<template>
  <div>
    <Header />

    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i> ANASAYFA</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#">anasayfa</a></li>
        </ul>
      </div>
      <div class="row">
        <div
          class="col-lg-12 col-md-12 rowHomepage"
          style="display: -webkit-box"
        >
          <div
            v-for="(item, index) in result"
            :key="index"
            class="col-md-6 col-lg-6"
            style="margin-bottom: 10px; height:550px; overflow-y: overlay"
          >
            <div class="tileHomepage" style="overflow-y: overlay">
              <div class="about-content">
                <button
                  type="button"
                  @click="changePost(item.id)"
                  class="btn btn-outline-success"
                >
                  Düzenle
                </button>
                <img
                  :src="item.image_url"
                  alt="About"
                  style="height: 410px;
                     width: 100%;
                    margin-left: auto;
                    margin-right: auto;
                    margin-bottom: 12px;
                  "
                  id="profile-containerHomepage"
                  @error="NoImg"
                />
                <div>
                  <a
                    style="font-size: 14px;font-type: bold;font-size: 20px"
                    class="readmore"
                    v-html="'<div>' + item.title + '</div>'"
                  ></a>
                  <br />
                  <p
                    style="
                         overflow: hidden;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                      "
                    v-html="'<div>' + item.content + '</div>'"
                  ></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="card-body tex-center d-flex align-items-center flex-column">
          <img
            style="margin-left: auto; margin-right: auto;margin-bottom:12px"
            id="profile-container"
            :src="selectedPost.image_url"
          />
          <input
            ref="file"
            type="file"
            style="display: none;"
            @change="onChange($event)"
            class="form-control"
          />
          <button
            class="btn btn-outline-secondary "
            type="button"
            @click="$refs.file.click()"
          >
            Resim Seç
          </button>
        </div>
      </div>
      <label>Başlık</label>
      <input v-model="selectedPost.title" style="width:100%" type="text" />
      <label>İçerik</label>
      <textarea
        v-model="selectedPost.content"
        rows="7"
        style="width:100%"
      ></textarea>
      <hr />
      <button
        @click="uploadFile()"
        style="width:15%"
        class="btn btn-outline-secondary"
      >
        Güncelle
      </button>
      <hr />
    </main>
    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      result: [],
      datas1: [],
      postDatas: [],
      selectedPost: [],
      pageItemId: null,
      uploadImage: "",
      homeImage: null,
      datas2: [],
      situation: false,
      img_base_url: store.state.img_base_url,
      imgSrc: store.state.img_base_url,
    };
  },
  mounted: function() {
    window.scrollTo(0, 0);
    var admin_token = localStorage.getItem("admin_token");
    if(!admin_token){
      this.$router.push("/");
    }
    let datas = [];
    let dataUrl = store.state.base_url + "Page/getPage.php?key=123";
    return axios
      .get(dataUrl)
      .then((response) => {
        datas = response.data.data;
        this.postDatas = response.data.data;
        this.result = datas;
        this.datas1 = datas[0];
        this.datas2 = datas[1];
        // console.log(this.datas1.image_url);
      })
      .catch((err) => {});
  },
  methods: {
    uploadFile: function() {
      this.file = this.$refs.file.files[0];
      if (!this.$refs.file.files[0]) {
        return this.sendData();
      }
      var result = this.result;
      var sendData = this.sendData;
      if (this.file.size > 2500000) {
        this.fileWarn =
          "Yükleyeceğiniz Dosya Boyutu 2.5 Mb'yi Aşamaz!  " +
          " Dosya Boyutunuz : " +
          this.file.size / 1000000 +
          "Mb";
        //console.log("dosya boyutu büyük");
        return;
      }
      let formData = new FormData();
      formData.append("file", this.file);
      var admin_token = localStorage.getItem("admin_token");
      var query =
        store.state.img_upload_admin_default +
        "?admin_token=" +
        admin_token +
        "&pageItemId=" +
        this.pageItemId;
      axios
        .post(query, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.result) {
            this.uploadImage = response.data.data;
            sendData();
          }
        });
    },
    sendData: function() {
      console.log("getLanguageDirection");
      var url = store.state.base_url + "Admin/updateHomePostById.php?key=123";

      var datas = {
        id: localStorage.getItem("id"),
        admin_token: localStorage.getItem("admin_token"),
        image_url: this.uploadImage,
        title: this.selectedPost.title,
        content: this.selectedPost.content,
        pageItemId: this.pageItemId,
      };
      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          if (response.data.result == true) {
            this.$swal({
              text: "Güncelleme İşleminiz Başarıyla Gerçekleştirildi!",
              icon: "success",
              closeOnClickOutside: true,
            });
            setTimeout(function() {location.reload()},1250);
           // location.reload();
          }

          ////conso.log(response);
        })
        .catch((error) => {
          //conso.log(error.response);
        });
    },
    NoImg: function(event) {
      setTimeout(() => (event.target.style.display = "none"), 1000);
    },
    onChange(e) {
      const file = e.target.files[0];
      this.selectedPost.image_url = URL.createObjectURL(file);
    },
    changePost(postId) {
      this.selectedPost = this.postDatas[postId - 1];
      this.pageItemId = postId;
      var uploadImageTemp = this.postDatas[postId - 1].image_url;
          uploadImageTemp = uploadImageTemp.split("/")
      this.uploadImage = uploadImageTemp[4];
      $("html,body").animate({ scrollTop: document.body.scrollHeight }, "slow");
    },

    reload: function() {
      location.reload();
    },
  },
  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/HomeUpdate.vue